import React, { SyntheticEvent, useEffect, useState } from 'react'
import DynamicSVG from '../../DynamicSVG/DynamicSVG'
import useModal from '../../../hooks/useModal'
import Modal from "../../Modal/Modal"
import "./TodoListItem.css"
import ComputeReadableDuration from '../../../Utilities/ComputeReadableDuration'
import TodoHandler from '../../../Database/handlers/TodoHandler'
import { ITodo, TodoObj } from '../../../types/interfaces'
import Drawer from '../../Drawer/Drawer'
import { Draggable, DraggableStateSnapshot } from 'react-beautiful-dnd'


interface TodoListItemProps{
  status:  "Pending" | "Ongoing" | "Completed",
  duration: number,
  id: number,
  title: string,
  index:number,
  priority: string,
  description: string,
  handleUpdateTodo: ((key:number,toStatus:"Pending"|"Ongoing"|"Completed") => void),
  handleDeleteTodo: ((key: number) => void),
  handleEditTodo:((updateDataObj:any)=> void)
}
export default function TodoListItem({
  status, duration, id, title, priority, description,index,
  handleUpdateTodo, handleDeleteTodo ,handleEditTodo}: TodoListItemProps) {
  const [isInfoOpen, toggleInfoModal] = useModal()
  const [isEditOpen, toggleEditModal] = useModal()
  const todoHandler = new TodoHandler()
  function SetDragState(snapshot:DraggableStateSnapshot) {
    if (snapshot.isDragging || snapshot.isDropAnimating) {
      return "Dragging"
    }else{return "NotDragging"}
  }
  function ShowDuration() {
    const durationElement = status == "Completed" ?
      <span className='TodoItem-Duration'>
        <b>Duration:</b> {ComputeReadableDuration(duration)}
      </span>
      : <span></span>
    return durationElement
  }
  
  function UpdateToNextStatus(event: SyntheticEvent) {
    const eventBtn = event.target as HTMLButtonElement
    if (handleUpdateTodo) {
      if (status == "Pending") {
        handleUpdateTodo(id,"Ongoing")
      } else if (status == "Ongoing") {
        handleUpdateTodo(id,"Completed")
      }
    } 
  }
  
  function DeleteTodoItem() {
    if (handleDeleteTodo) handleDeleteTodo(id)
  }

  function SubmitEditedTodo(event:SyntheticEvent){
    event.preventDefault()
    const form = event.target as HTMLFormElement
    const target = event.target as typeof event.target & {
      title: { value: string };
      description: { value: string };
      priority: { value: string };

    }

    const formObj = {
      id:id,
      title:target.title.value,
      description: target.description.value,
      priority: target.priority.value,
    }
    console.log(formObj)
    if (handleEditTodo) handleEditTodo(formObj)
    form.reset()
    toggleEditModal()
  }

  useEffect(() => {
    todoHandler.EditTodoItem(id,title,description,priority,index)
  }, [index])
  
  return (
    <Draggable draggableId={id.toString()} index={index} key={id.toString()||""}>
      {(provided, snapshot) => (
        <>
        <Modal isShowing={isInfoOpen} hideModal={toggleInfoModal}>
        <div>
          <p><b>Title :</b> {title}</p>
          <p><b>Description :</b> {description}</p>
          <p><b>Status :</b> {status}</p>
          {ShowDuration()}
          <br /><br /><br /><br />
          <span className={`Modal-Priority ${priority}`}>{priority} priority</span>
        </div>
      </Modal>
      <Drawer isOpen={isEditOpen} toggleDrawer={toggleEditModal}>
        <div>
          <h2 className='Drawer-Title'>Edit todo :</h2>
          <form id='Todo-Form' onSubmit={SubmitEditedTodo}>
            <div className='Input-Container'>
              <label htmlFor='Title-Input' >Title :</label>
              <input name='title' defaultValue={title}  id='Title-Input' required />
            </div>
            <div className='Input-Container'>
              <label htmlFor='Description-Input'>Description :</label>
              <textarea defaultValue={description}  name='description' id='Description-Input'  required/>
            </div>

            <div className='Input-Container'>
              <label htmlFor='Todo-priorities'>Priority :</label>
              <select defaultValue={priority} name='priority' id='Todo-priorities'>
                <option>Low</option>
                <option>Medium</option>
                <option>High</option>
              </select>
            </div>
            
            <br />
            <button type='submit' className='Modal-Submit'>
              Submit
            </button>
          </form>
        </div>
      </Drawer>
      <li ref={provided.innerRef} {...provided.dragHandleProps} {...provided.draggableProps} id={`${id}`} className={`TodoItem-Container ${SetDragState(snapshot)} ${status}`}>
        {/* <div className={`TodoItem-Status ${status}`}><b>{status}</b></div> */}
        <div className={`TodoItem-Priority ${priority}`}>
          {priority}
        </div>
        <h3 className="TodoItem-Title">
          {title}
        </h3>
        <span className="TodoItem-Desc">{description}</span>
        
        
        {ShowDuration()}
        {/* <button className='TodoItem-CheckBtn' onClick={UpdateToNextStatus} title="Pushes todo to next status">
          Check
        </button> */}
            <div className='TodoItem-GripArea'>
              <DynamicSVG SvgName="Grip-Icon" /></div>
        <div className='TodoItem-Buttons'>
        <button className="TodoItem-EditBtn" onClick={toggleEditModal} >
          <DynamicSVG SvgName="Edit-Icon"/>
        </button>
        <button className='TodoItem-InfoBtn' onClick={toggleInfoModal}>
          <DynamicSVG SvgName="Info-Icon"/>
        </button>
        <button className="TodoItem-DelBtn" onClick={DeleteTodoItem} >
          <DynamicSVG SvgName="Trash-Icon"/>
        </button>
        
        </div>
        
      </li>
        </>
      )}
      
    </Draggable>
  )
}
